// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"c5328baa","213":"2924cdac","246":"27274128","393":"31585c78","455":"834a3fad","777":"3644488c"}[chunkId] + ".chunk.js";
};